'use client'

import type { DirectoryRelease } from '@/lib/directory/aggregate-releases'

import { ReleaseRow } from './release-row'
import { ResultsEmpty } from './results-empty'

interface ReleaseListProps {
  releases: DirectoryRelease[]
  eagerImageCount: number
  compared: ReadonlySet<string>
  atMax: boolean
  facetLabels: Map<string, string>
  onToggleCompare: (slug: string) => void
  onClearFilters: () => void
}

// One row per product family, in the current sort order.
export const ReleaseList = ({
  releases,
  eagerImageCount,
  compared,
  atMax,
  facetLabels,
  onToggleCompare,
  onClearFilters,
}: ReleaseListProps) => {
  if (releases.length === 0) {
    return <ResultsEmpty onClearFilters={onClearFilters} />
  }

  return (
    <ol className="mt-5 flex list-none flex-col gap-3 p-0 md:mt-6">
      {releases.map((release, index) => (
        <ReleaseRow
          key={release.slug}
          release={release}
          eagerImage={index < eagerImageCount}
          isCompared={compared.has(release.slug)}
          atMax={atMax}
          facetLabels={facetLabels}
          onToggleCompare={onToggleCompare}
        />
      ))}
    </ol>
  )
}
